// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.angular-tooltip {
  transition: opacity 500ms;
  opacity: 0;

  position: absolute;
  background: var(--gw-secondary-base);
  z-index: 9999;
  padding: 3px 8px;
  border: none;
  color: #FFFFFF;
  pointer-events: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  max-width: 500px;
  border-radius: 0;
  text-decoration: none;
  text-align: center;
  font-family: inherit;
  font-style: normal;
  font-weight: 400;
  letter-spacing: normal;
  line-break: auto;
  line-height: 1.5;
  font-size: .875rem;
}

.angular-tooltip.angular-tooltip-fade-in {
  opacity: 1;
}

.angular-tooltip:after {
  border: solid transparent;
  content: " ";
  height: 0;
  width: 0;
  position: absolute;
  pointer-events: none;
}

.angular-tooltip:after {
  border-color: transparent;
  border-width: 5px;
}

.angular-tooltip.angular-tooltip-top:after {
  top: 100%;
  left: 50%;

  margin-left: -5px;
  border-top-color: var(--gw-secondary-base);
}

.angular-tooltip.angular-tooltip-top-left:after {
  top: 100%;
  left: calc(100% - 8px);

  margin-left: -5px;
  border-top-color: var(--gw-secondary-base);
}

.angular-tooltip.angular-tooltip-top-right:after {
  top: 100%;
  right: calc(100% - 8px);

  margin-right: -5px;
  border-top-color: var(--gw-secondary-base);
}


.angular-tooltip.angular-tooltip-right-top:after {
  top: calc(100% - 8px);
  right: 100%;

  margin-top: -5px;
  border-right-color: var(--gw-secondary-base);
}

.angular-tooltip.angular-tooltip-right:after {
  top: 50%;
  right: 100%;

  margin-top: -5px;
  border-right-color: var(--gw-secondary-base);
}

.angular-tooltip.angular-tooltip-right-bottom:after {
  bottom: calc(100% - 8px);
  right: 100%;

  margin-bottom: -5px;
  border-right-color: var(--gw-secondary-base);
}

.angular-tooltip.angular-tooltip-bottom:after {
  bottom: 100%;
  left: 50%;

  margin-left: -5px;
  border-bottom-color: var(--gw-secondary-base);
}

.angular-tooltip.angular-tooltip-bottom-left:after {
  bottom: 100%;
  left: calc(100% - 8px);

  margin-left: -5px;
  border-bottom-color: var(--gw-secondary-base);
}

.angular-tooltip.angular-tooltip-bottom-right:after {
  bottom: 100%;
  right: calc(100% - 8px);

  margin-right: -5px;
  border-bottom-color: var(--gw-secondary-base);
}

.angular-tooltip.angular-tooltip-left:after {
  top: 50%;
  left: 100%;

  margin-top: -5px;
  border-left-color: var(--gw-secondary-base);
}

.angular-tooltip.angular-tooltip-left-bottom:after {
  bottom: calc(100% - 8px);
  left: 100%;

  margin-bottom: -5px;
  border-left-color: var(--gw-secondary-base);
}

.angular-tooltip.angular-tooltip-left-top:after {
  top: calc(100% - 8px);
  left: 100%;

  margin-top: -5px;
  border-left-color: var(--gw-secondary-base);
}


`, "",{"version":3,"sources":["webpack://./packages/legacy-workbench/src/css/angular-tooltips.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,UAAU;;EAEV,kBAAkB;EAClB,oCAAoC;EACpC,aAAa;EACb,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,oBAAoB;EACpB,yBAAyB;EACzB,sBAAsB;EACtB,qBAAqB;EACrB,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,qBAAqB;EACrB,kBAAkB;EAClB,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,SAAS;EACT,QAAQ;EACR,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,SAAS;;EAET,iBAAiB;EACjB,0CAA0C;AAC5C;;AAEA;EACE,SAAS;EACT,sBAAsB;;EAEtB,iBAAiB;EACjB,0CAA0C;AAC5C;;AAEA;EACE,SAAS;EACT,uBAAuB;;EAEvB,kBAAkB;EAClB,0CAA0C;AAC5C;;;AAGA;EACE,qBAAqB;EACrB,WAAW;;EAEX,gBAAgB;EAChB,4CAA4C;AAC9C;;AAEA;EACE,QAAQ;EACR,WAAW;;EAEX,gBAAgB;EAChB,4CAA4C;AAC9C;;AAEA;EACE,wBAAwB;EACxB,WAAW;;EAEX,mBAAmB;EACnB,4CAA4C;AAC9C;;AAEA;EACE,YAAY;EACZ,SAAS;;EAET,iBAAiB;EACjB,6CAA6C;AAC/C;;AAEA;EACE,YAAY;EACZ,sBAAsB;;EAEtB,iBAAiB;EACjB,6CAA6C;AAC/C;;AAEA;EACE,YAAY;EACZ,uBAAuB;;EAEvB,kBAAkB;EAClB,6CAA6C;AAC/C;;AAEA;EACE,QAAQ;EACR,UAAU;;EAEV,gBAAgB;EAChB,2CAA2C;AAC7C;;AAEA;EACE,wBAAwB;EACxB,UAAU;;EAEV,mBAAmB;EACnB,2CAA2C;AAC7C;;AAEA;EACE,qBAAqB;EACrB,UAAU;;EAEV,gBAAgB;EAChB,2CAA2C;AAC7C","sourcesContent":[".angular-tooltip {\n  transition: opacity 500ms;\n  opacity: 0;\n\n  position: absolute;\n  background: var(--gw-secondary-base);\n  z-index: 9999;\n  padding: 3px 8px;\n  border: none;\n  color: #FFFFFF;\n  pointer-events: none;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n  max-width: 500px;\n  border-radius: 0;\n  text-decoration: none;\n  text-align: center;\n  font-family: inherit;\n  font-style: normal;\n  font-weight: 400;\n  letter-spacing: normal;\n  line-break: auto;\n  line-height: 1.5;\n  font-size: .875rem;\n}\n\n.angular-tooltip.angular-tooltip-fade-in {\n  opacity: 1;\n}\n\n.angular-tooltip:after {\n  border: solid transparent;\n  content: \" \";\n  height: 0;\n  width: 0;\n  position: absolute;\n  pointer-events: none;\n}\n\n.angular-tooltip:after {\n  border-color: transparent;\n  border-width: 5px;\n}\n\n.angular-tooltip.angular-tooltip-top:after {\n  top: 100%;\n  left: 50%;\n\n  margin-left: -5px;\n  border-top-color: var(--gw-secondary-base);\n}\n\n.angular-tooltip.angular-tooltip-top-left:after {\n  top: 100%;\n  left: calc(100% - 8px);\n\n  margin-left: -5px;\n  border-top-color: var(--gw-secondary-base);\n}\n\n.angular-tooltip.angular-tooltip-top-right:after {\n  top: 100%;\n  right: calc(100% - 8px);\n\n  margin-right: -5px;\n  border-top-color: var(--gw-secondary-base);\n}\n\n\n.angular-tooltip.angular-tooltip-right-top:after {\n  top: calc(100% - 8px);\n  right: 100%;\n\n  margin-top: -5px;\n  border-right-color: var(--gw-secondary-base);\n}\n\n.angular-tooltip.angular-tooltip-right:after {\n  top: 50%;\n  right: 100%;\n\n  margin-top: -5px;\n  border-right-color: var(--gw-secondary-base);\n}\n\n.angular-tooltip.angular-tooltip-right-bottom:after {\n  bottom: calc(100% - 8px);\n  right: 100%;\n\n  margin-bottom: -5px;\n  border-right-color: var(--gw-secondary-base);\n}\n\n.angular-tooltip.angular-tooltip-bottom:after {\n  bottom: 100%;\n  left: 50%;\n\n  margin-left: -5px;\n  border-bottom-color: var(--gw-secondary-base);\n}\n\n.angular-tooltip.angular-tooltip-bottom-left:after {\n  bottom: 100%;\n  left: calc(100% - 8px);\n\n  margin-left: -5px;\n  border-bottom-color: var(--gw-secondary-base);\n}\n\n.angular-tooltip.angular-tooltip-bottom-right:after {\n  bottom: 100%;\n  right: calc(100% - 8px);\n\n  margin-right: -5px;\n  border-bottom-color: var(--gw-secondary-base);\n}\n\n.angular-tooltip.angular-tooltip-left:after {\n  top: 50%;\n  left: 100%;\n\n  margin-top: -5px;\n  border-left-color: var(--gw-secondary-base);\n}\n\n.angular-tooltip.angular-tooltip-left-bottom:after {\n  bottom: calc(100% - 8px);\n  left: 100%;\n\n  margin-bottom: -5px;\n  border-left-color: var(--gw-secondary-base);\n}\n\n.angular-tooltip.angular-tooltip-left-top:after {\n  top: calc(100% - 8px);\n  left: 100%;\n\n  margin-top: -5px;\n  border-left-color: var(--gw-secondary-base);\n}\n\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
